module.exports = __webpack_public_path__ + "static/media/zubi.de8d690c.mp3";